exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new_icon_svip[data-v-286c0cc2]{height:16px!important;width:24px!important}.flex_container[data-v-286c0cc2],.focus_login_notvip .user_info .user_management .flex_container[data-v-286c0cc2]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}", ""]);

// exports
